import { render, staticRenderFns } from "./TenantGuidelinesManage.vue?vue&type=template&id=e60e0e7e"
import script from "./TenantGuidelinesManage.vue?vue&type=script&lang=js"
export * from "./TenantGuidelinesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports